// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"6898351b","859":"0d98b539"}[chunkId] + ".chunk.js";
};